<template>
  <default-dialog :dialog="true" :loading="loading_modality" fullscreen return_params>
    <template slot="title">
      Detalhes {{one_modality.name}}
    </template>
    <template slot="content">
      <dialog-loading v-if="saving" loadingText='Salvando...'></dialog-loading>
      <v-container fluid>
        <v-expansion-panels popout multiple flat v-if="!loading_modality" active-class="elevation-4" :readonly="is_editing.employees">
          <v-expansion-panel class="exp-panel" id="main-data">
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-information</v-icon>
                Informações básicas
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <show-modality-main-data :main_data="one_modality"></show-modality-main-data>
            </v-expansion-panel-content>
          </v-expansion-panel>
    
          <v-expansion-panel class="exp-panel" id="contacts">
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-account-box</v-icon>
                Contato
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <show-modality-contact :contact="one_modality.contact"></show-modality-contact>
            </v-expansion-panel-content>
          </v-expansion-panel>
    
          <v-expansion-panel class="exp-panel" id="address">
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-map</v-icon>
                Endereço
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <show-modality-address :address="one_modality.address"></show-modality-address>
            </v-expansion-panel-content>
          </v-expansion-panel>
    
          <v-expansion-panel class="exp-panel mb-1" id="address">
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-account-multiple</v-icon>
                Funcionários
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <show-modality-employees @editing="is_editing.employees = $event"></show-modality-employees>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-panel mb-1" id="address" v-if="one_modality.solution == 'retail'">
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-qrcode</v-icon>
                Pix galpão
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>

              <card-loading class="my-3" v-if="loading_companies_pix"></card-loading>
              <v-card flat v-if="!loading_companies_pix">
                <v-card-title class="d-flex align-center justify-end">
                  <f-btn edit
                    small class="ml-4 mt-3" 
                    @click="is_editing.pix = true" 
                    v-if="!is_editing.pix"
                  ></f-btn>
                  <f-btn cancel
                    small class="ml-4 mt-3" 
                    @click="cancelEditPix" 
                    v-if="is_editing.pix"
                  ></f-btn>
                  <f-btn save 
                    small class="ml-4 mt-3" 
                    @click="saveEditPix"
                    v-if="is_editing.pix"
                  ></f-btn>
                </v-card-title>
                <v-card-text>
                  <pix-gateway-form ref="gateway" :gateway_key="one_modality.company_pix" :read_only="!is_editing.pix" @gatewayKey="handleGatewayKey"></pix-gateway-form>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
        </v-expansion-panels> 
      </v-container>

    </template>
    <template slot="actions">
      <f-btn close @click="$router.push({name:'ModalityList', params: {solution: $route.params.solution}})"></f-btn>
    </template>
  </default-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Api from '@/api/index';

export default {
  name: 'ShowModalityRegister',
  components: {
    ShowModalityMainData: () => import('./show/ShowModalityMainData'),
    ShowModalityAddress: () => import('./show/ShowModalityAddress'),
    ShowModalityContact: () => import('./show/ShowModalityContact'),
    ShowModalityEmployees: () => import('./show/ShowModalityEmployees'),
    PixGatewayForm: () => import('@/_backoffice/_registrations/components/companies/forms/PixGatewayForm.vue'), 
  },
  data() {
    return {
      saving: false,
      loading_modality: false,
      loading_address: false,
      loading_contacts: false,
      loading_employees: false,
      loading_companies_pix: false,
      companies: [],
      selected_company: {
        data:{
          attributes:{
            gateway_key: ''
          }
        }
      },
      is_editing:{
        employees: false,
        pix: false
      },
      modality: {
        company_pix: ''
      }
    }
  },
  mounted () {
    this.getCompanies()
    this.loading_modality = true

    this.showOneModality(this.$route.params.id).then( async (r)=>{
      try {
        await this.getAddress(this.$route.params.id)
        await this.getContact(this.$route.params.id)
        this.loading_modality = false
      } catch (error) {
        throw new Error(error)
      }
    }).catch(err=>{
      console.log({err});
    })
  },
  beforeDestroy () {
      this.clearOneModality();
  },
  methods: {
    saveEditPix(){
      if (!this.$refs.gateway?.validate?.()) {
        this.addNotification({
          type: 'error',
          msg: 'Selecione uma empresa com gateway key para o PIX.',
        })
        return
      }

      let new_gateway_key = this.$refs.gateway.getSelectedKey()
      if (!String(new_gateway_key || '').trim()) {
        this.addNotification({
          type: 'error',
          msg: 'Gateway key não pode ficar vazia.',
        })
        return
      }

      this.saving = true
      let updated_modality = {
        id: this.one_modality.id,
        company_pix: new_gateway_key
      }
      Api.Modality.defaultUpdate(updated_modality).then(()=>{
        this.successUpdated()
      }).catch(()=>{
        this.errorUpdated()
      })
      .finally(()=>{
        this.saving = false
        this.is_editing.pix = false
      })
    },
    cancelEditPix(){
      this.$refs.gateway.cancelEdit()
      this.is_editing.pix = false
    },
    handleGatewayKey(el){
      console.log(el)
    },
    getCompanies(){
      this.modality.company_pix = 'batata'
      this.modality.company_pix = this.one_modality.company_pix
      Api.Company.index({only_with_credentials: true}).then(r=> this.companies = r.data).catch(err=> {
        console.log({err})
      }).finally(() => {

      })
    },
    ...mapActions({
      showOneModality: 'Modality/show',
      clearOneModality: 'Modality/clearOneModality',
    }),

    ...mapMutations({
      setAddress: 'Modality/setModalityAddress',
      setContact: 'Modality/setModalityContact',
    }),

    async getAddress(id){
      this.loading_address = true
      return Api.Address.indexByModel({model: 'modalities', id: id}).then(r=>r.data).then(address => {
        this.setAddress(address)
        return true
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_address = false
      })
    },
    
    getContact(id){
      this.loading_contacts = true
      return Api.Contact.indexByModel({model: 'modalities', id: id}).then(r=>r.data).then(contact => {
        // console.log('pegou contacts na api');
        this.setContact(contact)
        return true
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_contacts = false
      })
    },

    
  },
  beforeCreate () {
    if(!this.$route.params.solution){
      this.$router.push({name: 'Home'})
    };
  },
  computed: {
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
}
</script>

<style lang="scss" scoped>
.exp-panel{
  border-bottom: solid #ddd 1px;
}
</style>
